import Cookies from 'js-cookie'

const token = 'charhoo-admin-token';

// 保存token
export function setToken(CourseId) {
    localStorage.setItem(token,CourseId);
    return Cookies.set(token, CourseId);
}
// 获取token
export function getToken() {
    let data = localStorage.getItem(token);
    if(data) {
        Cookies.set(token, data);
    }
    return Cookies.get(token);
}
// 移除token
export function removeToken() {
    localStorage.removeItem(token);
    return Cookies.remove(token);
}